import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { getVersionCrud } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/versions/helpers/getVersionCrud'

export const updateVersionName = (selectedVersion: IELTData, versionName: string) => {
  return getVersionCrud().update({ formId: '1233', code: 'executive-leadership-team-1233' }, [
    { ...selectedVersion, VersionName: versionName },
  ])
}
